import { render, staticRenderFns } from "./ImgRoom.vue?vue&type=template&id=3737ea5f&"
import script from "./ImgRoom.vue?vue&type=script&lang=js&"
export * from "./ImgRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports